"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const createReport_1 = require("../../../app/dist/createReport");
exports.toolDef = {
    name: 'loom_create_report',
    description: "Persist an already-synthesized analytical report as a standalone `report` artifact doc (rp_ ULID, born status \"active\", version 1) under loom/reports/ (cross-weave / roadmap) or loom/{weave}/reports/ (weave-scoped). A report is a LEAF SNAPSHOT — it is deliberately NOT loaded into project state, so it is excluded by construction from refs, staleness, derived status, and requires_load. You (the agent) author the report `content` after reading the assembled slice from the `report` prompt or the `loom report` CLI; this tool only writes it. Frontmatter is minimal (kind + generated_at) — scope + sources are recorded in a body `## Provenance` section. Do not edit report files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            kind: { type: 'string', description: 'Report kind slug (e.g. "project-overview").' },
            title: { type: 'string', description: 'Concise human-readable report title (also drives the filename).' },
            content: { type: 'string', description: 'The synthesized report body (markdown, no frontmatter). A `## Provenance` section is appended for you.' },
            weave_slug: { type: 'string', description: 'Optional weave slug — omit for a cross-weave/roadmap report (writes to top-level loom/reports/).' },
            scope: {
                type: 'object',
                description: 'Provenance: the filter that produced the report. Rendered into the body Provenance section.',
                properties: {
                    weaves: { type: 'array', items: { type: 'string' } },
                    threads: { type: 'array', items: { type: 'string' } },
                    from: { type: 'string' },
                    to: { type: 'string' },
                },
            },
            sources: { type: 'array', items: { type: 'string' }, description: 'Doc ids / resource URIs the report was synthesized from (provenance).' },
        },
        required: ['kind', 'title', 'content'],
    },
};
async function handle(root, args) {
    const result = await (0, createReport_1.createReport)({
        kind: args['kind'],
        title: args['title'],
        content: args['content'],
        weaveSlug: args['weave_slug'],
        scope: args['scope'],
        sources: args['sources'],
    }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
